import React, { createContext, useContext, useState, useEffect, useCallback, ReactNode } from "react";

// Type for the context value
interface StudioHeaderActionsContextValue {
  rightActions: ReactNode | null;
  setRightActions: (node: ReactNode | null) => void;
}

// Create the context with a default value
const StudioHeaderActionsContext = createContext<StudioHeaderActionsContextValue>({
  rightActions: null,
  setRightActions: () => {},
});

// Provider component
interface StudioHeaderActionsProviderProps {
  children: ReactNode;
}

export function StudioHeaderActionsProvider({ children }: StudioHeaderActionsProviderProps) {
  const [rightActions, setRightActions] = useState<ReactNode | null>(null);

  const value: StudioHeaderActionsContextValue = {
    rightActions,
    setRightActions,
  };

  return (
    <StudioHeaderActionsContext.Provider value={value}>
      {children}
    </StudioHeaderActionsContext.Provider>
  );
}

// Hook to read the current right actions (used by StudioAppHeader)
export function useStudioHeaderActions() {
  const context = useContext(StudioHeaderActionsContext);
  return context;
}

// Hook to set right actions from a page component
// Automatically clears on unmount
export function useSetStudioHeaderRightActions(
  node: ReactNode | null,
  deps: React.DependencyList = []
) {
  const { setRightActions } = useContext(StudioHeaderActionsContext);

  useEffect(() => {
    setRightActions(node);
    
    // Cleanup: clear actions when component unmounts
    return () => {
      setRightActions(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

